<template>
  <div>
    <div class="container-fluid">
      <div id="section-3-top">
        <div>
          <img src="../assets/images/quiz.png" alt="" />
        </div>
        <div>
          Regardez les 3 vidéos
          et testez vos connaissances
          sur le Débit Différé
        </div>
      </div>
      <div id="section-3-bottom">
        <div class="row row-spaced">
          <div class="col-sm-6">
            <img
              v-if="thumbnail"
              class="thumbnail-play"
              src="../assets/images/play.png"
              data-trackingclass="landing-page-clic-bouton"
              :data-trackinginfo="trackingVideo"
              @click.prevent="thumbnail = false"
            />

            <video
              v-else
              id="section-3-video"
              :src="motion"
              controls playsinline autoplay
            ></video>

            <el-progress :percentage="progress" :show-text="false" color="#25cfce" />
          </div>
          <div class="col-sm-6">
            <div>
              <div v-if="endGame" class="messages section-3-content">
                <img src="../assets/images/end-quiz.png" class="icon-motion" />
                <h3>
                  <span>FÉLICITATIONS !</span>
                  <br />vous maîtrisez parfaitement<br> les avantages du Debit Différé.
                </h3>

                <p>Adoptez ce service pour votre carte dès maintenant !</p>

                <p>
                  <a
                    :href="cta"
                    class="the-button"
                    target="_top"
                    data-trackingclass="landing-page-clic-bouton"
                    :data-trackinginfo="trackingInfo"
                  >
                    demandez le Débit Différé
                  </a>
                </p>
              </div>

              <div v-else-if="newMotion" class="messages section-3-content">
                <img src="../assets/images/new-motion.png" class="icon-motion" />
                <h3>
                  <span>Regardez la nouvelle vidéo : </span>
                  <br />avant de passer au {{ question.level }}
                </h3>

                <el-button
                  data-trackingclass="landing-page-clic-bouton"
                  :data-trackinginfo="trackingInfo"
                  @click="newMotion = false"
                >
                  Passer au {{ question.level }}
                </el-button>
              </div>
              <div v-else class="section-3-content">
                <h3>
                  <span>{{ question.level }} : </span>
                  <br />{{ question.title }}
                </h3>
                <p>
                  {{ question.subtitle }} :
                </p>
                <el-radio-group v-model="answer">
                  <el-radio
                    v-for="(answer, index) in question.answers"
                    v-bind:class="{ success: success(index), error: error(index) }"
                    :key="index"
                    :value="index"
                    :label="index"
                  >
                    <i class="el-icon-success" />
                    <i class="el-icon-error" />
                    {{ answer }}
                  </el-radio>
                </el-radio-group>
                <div>
                  <el-button
                    v-if="(step + 1) !== questions.length"
                    class="next"
                    :disabled="answer < 0"
                    @click="step++"
                  >
                    Question suivante
                    <i class="el-icon-arrow-right" />
                  </el-button>

                  <div v-if="error(answer)" class="error-response">
                    <i class="el-icon-circle-close" />
                    Mauvaise réponse
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    cta: String
  },
  data () {
    return {
      step: 0,
      answer: -1,
      newMotion: false,
      endGame: false,
      thumbnail: true,
      questions: [
        {
          title: '+ de tranquillité avec le Débit Différé',
          level: '1er niveau',
          subtitle: 'Grâce à ma carte Débit Différé nous pouvons acheter ce superbe landau pour l’arrivée de notre bébé',
          success: 0,
          answers: [
            'Tout de suite en ayant le temps de reconstituer ma trésorerie',
            'A la fin du mois, après le versement de mon salaire',
            'A condition de faire un emprunt'
          ]
        },
        {
          title: '+ de tranquillité avec le Débit Différé',
          level: '1er niveau',
          subtitle: 'Je dois changer mes freins après un accident de voiture. Avec ma carte Débit Différé',
          success: 1,
          answers: [
            'Je vais devoir emprunter la voiture de ma belle-mère',
            'Ma dépense sera prélevée à la fin du mois, je peux anticiper et adapter ma trésorerie',
            'Je vais devoir prendre le bus'
          ]
        },
        {
          title: '+ de tranquillité avec le Débit Différé',
          level: '1er niveau',
          subtitle: 'Un site de voyage en ligne me propose un week-end en promotion. Avec ma carte Débit Différé',
          success: 1,
          answers: [
            'Il faudra attendre la fin du mois pour réserver et la promotion sera passée',
            'A nous le weekend sans stress pour notre trésorerie',
            'Vite j’organise une cagnotte en ligne pour financer notre week-end'
          ]
        },
        {
          title: '+ de simplicité avec le Débit Différé',
          level: '2ème niveau',
          subtitle: 'Avec ma carte Débit Différé tous mes achats effectués dans le mois sont',
          success: 1,
          answers: [
            'Prélevés en fin de semaine',
            'Prélevés en une seule fois à la fin du mois',
            'Prélevés tous les jours'
          ]
        },
        {
          title: '+ de simplicité avec le Débit Différé',
          level: '2ème niveau',
          subtitle: 'Toutes mes dépenses sont prélevées en fin de mois sauf',
          success: 1,
          answers: [
            'Mes achats en magasin',
            'Mes retraits d’espèces',
            'Mes achats sur internet'
          ]
        },
        {
          title: '+ de contrôle avec le Débit Différé',
          level: '3ème niveau',
          subtitle: 'Comment suivre mes dépenses à tout moment même à distance',
          success: 0,
          answers: [
            'Grâce à mon application Ma banque et dans mon espace Crédit Agricole en ligne',
            'Impossible, je dois attendre la fin du mois',
            'Je dois me rendre dans mon agence'
          ]
        },
        {
          title: '+ de contrôle avec le Débit Différé',
          level: '3ème niveau',
          subtitle: 'Une fin de mois difficile',
          success: 1,
          answers: [
            'Je vais devoir payer des agios',
            'Je peux effectuer un virement depuis un autre compte avant le prélèvement différé de mes achats par carte',
            'Je contacte un marabout pour arranger la situation'
          ]
        }
      ]
    }
  },
  computed: {
    question () {
      return this.questions[this.step]
    },
    progress () {
      return (Math.ceil(100 / this.questions.length) + 2) * this.step
    },
    motion () {
      let level = this.question.level.match(/^[0-9]/)
      return '/static/motions/' + level[0] + '.mp4'
    },
    trackingInfo () {
      let level = this.question.level.match(/^[0-9]/)
      if (this.newMotion) {
        return 'landing-page-CAPS-debitdiffere-passer-niveau-' + level[0]
      }
      if (this.endGame) {
        return 'landing-page-CAPS-debitdiffere-finaliser'
      }
    },
    trackingVideo () {
      let level = this.question.level.match(/^[0-9]/)
      return 'landing-page-CAPS-debitdiffere-video-n-' + level[0]
    }
  },
  methods: {
    success (index) {
      return this.answer >= 0 && index === this.question.success
    },
    error (index) {
      return this.answer === index && index !== this.question.success && index !== -1
    }
  },
  watch: {
    step () {
      this.answer = -1
    },
    question (newValue, oldValue) {
      if (newValue && oldValue && newValue.level !== oldValue.level) {
        this.newMotion = true
        this.thumbnail = true
      }
    },
    answer (value) {
      if (value !== -1 && (this.step + 1) === this.questions.length) {
        window.setTimeout(() => {
          this.endGame = true
        }, 1500)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .thumbnail-play {
    cursor: pointer;
  }
  .el-progress {
    margin-top: 20px;
  }
  .el-radio-group {
    display: block;
    margin: 0 auto 30px;
    width: 100%;

    .el-radio {
      color: #fff;
      margin-bottom: 20rem;
      position: relative;
      display: block;
    }
  }
  .el-button {
    float: right;
    background: transparent;
    border-color: #fff;
    color: #fff;
  }
  .messages {
    text-align: center;

    .icon-motion {
      max-width: 100px;
      margin: 0 auto 30px;
    }

    .el-button {
      float: none;
    }

    h3 {
      text-transform: none !important;
    }

    p {
      font-size: 20rem !important;

      a {
        border: 1px solid white;

        &:hover {
          border-color: black;
        }
      }
    }
  }
  #section-3 #section-3-bottom .section-3-content h3 {
    font-size: 30rem;

    span {
      font-size: 38rem;
    }
  }
  @media screen and (max-width: 767px) {
    .el-button {
      float: none;
      margin-bottom: 15px;
    }
  }
</style>

<style lang="scss">
  .section-3-content {
    .el-radio__label {
      white-space: normal;
      font-size: 22rem;
      line-height: 30rem;

      .el-icon-success, .el-icon-error {
        position: absolute;
        left: -3px;
        top: 0;
        font-size: 30rem;
        z-index: 1000;
        display: none;
        color: #b0c740 !important;
      }
      .el-icon-error {
        color: #ff9000 !important;
      }
    }
    .el-radio__input.is-checked + .el-radio__label {
      color: #fff;
    }
    .success .el-icon-success, .error .el-icon-error {
      display: block;
    }
    .success .el-radio__input, .error .el-radio__input {
      visibility: hidden;
    }
    .error-response {
      color: #ff9000;
      text-transform: uppercase;
      line-height: 50rem;
      margin-left: -5px;

      .el-icon-circle-close {
        font-size: 50rem;
        margin-right: 10px;
        float: left;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Quiz.vue